<script setup lang="ts">
import { useTranslate } from '@tolgee/vue'

import { useEditorStore } from '@/stores/Editor'
import { useAccountStore } from '@/stores/Account'
import { PLAN_TYPES } from '@/api/interfaces'

import UploadImage from '@/components/common/UploadImage.vue'
import LockIcon from '@/components/icons/LockIcon.vue'
import UpgradePlanButton from '@/components/editor/UpgradePlanButton.vue'

const editorStore = useEditorStore()
const accountStore = useAccountStore()
const { t } = useTranslate('local')

const handleUpload = (value: string) => {
  editorStore.editor.hero.logo.url = value
}
</script>

<template>
  <div class="editor-settings-logo mb-5">
    <UploadImage
      @upload="handleUpload"
      :default-image="editorStore.editor.hero.logo.url"
      :disabled="editorStore.publishLoading"
    />
    <div class="editor-settings-logo-status" :class="{ disabled: accountStore.hasStarterPlan }">
      <div class="d-flex justify-space-between align-center">
        <v-checkbox
          v-model="editorStore.editor.hero.logo.visible"
          :disabled="editorStore.publishLoading || accountStore.hasStarterPlan"
          :label="t('EditorHeroSettings.logo.fields.removeLogo.label')"
        />
        <LockIcon v-if="accountStore.hasStarterPlan" color="red" />
      </div>
      <p>{{ t('EditorHeroSettings.logo.fields.removeLogo.placeholder') }}</p>
      <UpgradePlanButton v-if="accountStore.hasStarterPlan" :plan="PLAN_TYPES.GROWTH" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.editor-settings-logo-status {
  position: relative;

  &.disabled {
    color: var(--gray-light-a7);
  }
}
</style>
